// Auto-generated by scripts/generate-registry.mjs from packages/modules/rattan_hex_stand_type_a/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const rattan_hex_stand_type_a: ModuleSchema = {
  "id": "rattan_hex_stand_type_a",
  "uniqueId": "B3D_NY035",
  "createdAt": "2026-10-28T06:55:30.555Z",
  "updatedAt": "2026-10-28T06:55:30.556Z",
  "label": "Rattan Hex Stand",
  "description": "Structural Type A interlocking rattan stand.",
  "category": "rattan",
  "tags": [
    "rattan-hex-stand-type-a"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Stand Width",
      "min": 50,
      "max": 110,
      "default": 72,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "depth",
      "label": "Stand Depth",
      "min": 50,
      "max": 110,
      "default": 72,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Stand Height",
      "min": 30,
      "max": 100,
      "default": 58,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "cornerRadius",
      "label": "Corner Radius",
      "min": 4,
      "max": 24,
      "default": 12,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch",
      "min": 4,
      "max": 10,
      "default": 6,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude",
      "min": 0.2,
      "max": 1.5,
      "default": 0.8,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "faceCycles",
      "label": "Odd Cycles Per Face",
      "min": 3,
      "max": 15,
      "default": 7,
      "step": 2,
      "unit": "cycles"
    },
    {
      "key": "layerOverlap",
      "label": "Layer Overlap",
      "min": 0.1,
      "max": 0.8,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm"
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness",
      "min": 0.6,
      "max": 2,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "strandHeight",
      "label": "Strand Height",
      "min": 1,
      "max": 4,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "padThickness",
      "label": "Floor Pad Thickness",
      "min": 1,
      "max": 4,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "woven_body",
      "label": "Structural Type A woven body and floor pad",
      "default": "#64748b",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "hex_stand",
      "label": "Rattan Hex Stand",
      "name": "Rattan Hex Stand",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "woven_body",
          "label": "Structural Type A woven body and floor pad",
          "name": "Structural Type A woven body and floor pad",
          "groupId": 0,
          "colorKey": "woven_body",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Rattan Hex Stand"
    }
  ]
};
